<template>
  <div class="container">
    <div class="content">
      <div class="box">
        <div class="title">
          <span>{{jobInfo.Name}}</span>
          <div class="fragment">
            <div class="desc" v-html="jobInfo.RegistrationDesc"></div>
            <div style="display: flex;margin-left:20px">
              <el-button class="k-btn" @click="handleAddxy">添加报名学员</el-button>
            </div>
          </div>
        </div>
        <el-table v-if="courseId == 3" class="table-xueyuan" id="xytable" :data="employees">
          <div class="tmpl" slot="empty">
            <a style="color:#16cfd0" href="javascript:void(0)" @click="handleAddxy">未添加任何报名学员，点击此处添加报名学员</a>
          </div>
          <el-table-column label="" width="90">
            <template slot-scope="scope">
              <div class="pic" style="height:77px">
                <img :src="scope.row.Pic" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名/性别/身份证号" width="190">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span style="color: #333333;font-weight: 600;">{{scope.row.Name}}</span>
                  <span>{{scope.row.Sex==0?'男':'女'}}</span>
                </div>
                <div>
                  <span>{{scope.row.IdNumber}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="证书类型" width="170">
            <template slot-scope="scope">
              <div class="item item-imgs">
                <div v-if="registLearnSettings.ZyzsTypeVisible" class="input_item">
                  <div>
                    <el-select class="k-input" v-model="scope.row.ZyzsType" @change="zyzsTypeUpdate($event, scope.row.EmployeeId)" clearable placeholder="证书类型">
                      <el-option label="注册类电子证书" :value="1"></el-option>
                      <el-option label="电子职称证书" :value="2"></el-option>
                      <el-option label="纸质职称证书" :value="3"></el-option>
                    </el-select>
                  </div>
                  <span v-show="scope.row.ZyzsType ? false : true" class="span_error">请选择</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="证书 | 评审表或人社红头文件 | 承诺书 | 身份证国徽面 | 身份证人像面">
            <template slot-scope="scope">
              <div class="item item-imgs">
                <div v-if="registLearnSettings.ZyzsVisible && (scope.row.ZyzsType == 2 || scope.row.ZyzsType == 3)">
                  <div v-if="scope.row.PicZyzs==null" @click="fileUpdate('file_zyzs_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">职称证书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicZyzs' :id="'img_zyzs_'+scope1.item.EmployeeId" :src="scope1.item.PicZyzs == null ? null : scope1.item.PicZyzs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_zyzs_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_zyzs_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_zyzs_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 14)">
                </div>
                <div v-if="registLearnSettings.ZcjzszsVisible && scope.row.ZyzsType == 1">
                  <div v-if="scope.row.PicZcjzszs==null" @click="fileUpdate('file_jzs_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">注册类电子证书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicZcjzszs' :id="'img_jzs_'+scope1.item.EmployeeId" :src="scope1.item.PicZcjzszs == null ? null : scope1.item.PicZcjzszs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_jzs_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_jzs_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_jzs_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row,3)">
                </div>
                <div v-if="registLearnSettings.PsbVisible && scope.row.ZyzsType == 3">
                  <div v-if="scope.row.FilePsb==null" @click="fileUpdate('file_psb_'+scope.row.EmployeeId, scope.row)" style="display: flex; align-items: center; flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:12px;line-height: 14px; padding-left: 4px;">评审表或人社红头文件</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img style="object-fit: contain;" :src="pdfIconUrl" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickPdf(scope.row.FilePsb)">查看文件</div>
                      <div @click="fileUpdate('file_psb_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_psb_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="application/pdf" @change="handlePdfSuccess($event,scope.row, 1)">
                </div>
                <div v-if="registLearnSettings.CnsVisible">
                  <div v-if="scope.row.PicCns == null" @click="fileUpdate('file_cns_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">承诺书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row" :src="scope.row.PicCns">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicCns' :id="'img_cns_'+scope1.item.EmployeeId" :src="scope1.item.PicCns == null ? null : scope1.item.PicCns + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_cns_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_cns_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_cns_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row,1)">
                </div>
                <div v-if="registLearnSettings.SfzfmVisible">
                  <div v-if="scope.row.PicSfzfm==null" @click="fileUpdate('file_sfzfm_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">身份证国徽面</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicSfzfm' :id="'img_sfzfm_'+scope1.item.EmployeeId" :src="scope1.item.PicSfzfm == null ? null : scope1.item.PicSfzfm + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_sfzfm_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_sfzfm_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_sfzfm_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 8)">
                </div>
                <div v-if="registLearnSettings.SfzzmVisible">
                  <div v-if="scope.row.PicSfzzm==null" @click="fileUpdate('file_sfzzm_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">身份证人像面</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicSfzzm' :id="'img_sfzzm_'+scope1.item.EmployeeId" :src="scope1.item.PicSfzzm == null ? null : scope1.item.PicSfzzm + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_sfzzm_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_sfzzm_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_sfzzm_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 7)">
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="80">
            <template slot-scope="scope">
              <div class="cell-btn" @click="handleRemoveEmployee(scope.row)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                  <path id="trash-alt" class="cls-1" fill="#16cfd0" d="M8.375,13h.75a.375.375,0,0,0,.375-.375V5.875A.375.375,0,0,0,9.125,5.5h-.75A.375.375,0,0,0,8,5.875v6.75A.375.375,0,0,0,8.375,13ZM13.5,2.5H10.925L9.862.728A1.5,1.5,0,0,0,8.575,0H5.425A1.5,1.5,0,0,0,4.138.728L3.075,2.5H.5A.5.5,0,0,0,0,3v.5A.5.5,0,0,0,.5,4H1V14.5A1.5,1.5,0,0,0,2.5,16h9A1.5,1.5,0,0,0,13,14.5V4h.5a.5.5,0,0,0,.5-.5V3A.5.5,0,0,0,13.5,2.5ZM5.37,1.591A.188.188,0,0,1,5.531,1.5H8.469a.188.188,0,0,1,.161.091l.546.909H4.825ZM11.5,14.5h-9V4h9ZM4.875,13h.75A.375.375,0,0,0,6,12.625V5.875A.375.375,0,0,0,5.625,5.5h-.75a.375.375,0,0,0-.375.375v6.75A.375.375,0,0,0,4.875,13Z" />
                </svg>
                &nbsp;删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else class="table-xueyuan" id="xytable" :data="employees">
          <div class="tmpl" slot="empty">
            <a style="color:#16cfd0" href="javascript:void(0)" @click="handleAddxy">未添加任何报名学员，点击此处添加报名学员</a>
          </div>
          <el-table-column label="" width="90">
            <template slot-scope="scope">
              <div class="pic" style="height:77px">
                <img :src="scope.row.Pic" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名/性别/身份证号" width="190">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span style="color: #333333;font-weight: 600;">{{scope.row.Name}}</span>
                  <span>{{scope.row.Sex==0?'男':'女'}}</span>
                </div>
                <div>
                  <span>{{scope.row.IdNumber}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="相关材料">
            <template slot-scope="scope">
              <div class="item item-imgs">
                <div v-if="registLearnSettings.SfzfmVisible">
                  <div v-if="scope.row.PicSfzfm==null" @click="fileUpdate('file_sfzfm_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">身份证国徽面</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicSfzfm' :id="'img_sfzfm_'+scope1.item.EmployeeId" :src="scope1.item.PicSfzfm == null ? null : scope1.item.PicSfzfm + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_sfzfm_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_sfzfm_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_sfzfm_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 8)">
                </div>
                <div v-if="registLearnSettings.SfzzmVisible">
                  <div v-if="scope.row.PicSfzzm==null" @click="fileUpdate('file_sfzzm_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">身份证人像面</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicSfzzm' :id="'img_sfzzm_'+scope1.item.EmployeeId" :src="scope1.item.PicSfzzm == null ? null : scope1.item.PicSfzzm + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_sfzzm_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_sfzzm_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_sfzzm_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 7)">
                </div>
                <div v-if="registLearnSettings.WorkYearVisible" class="input_item">
                  <div>
                    <el-input class="k-input" type="number" v-model="scope.row.WorkYear" @change="workYearUpdate($event, scope.row.EmployeeId)" clearable placeholder="工作年限"></el-input>
                  </div>
                  <span v-show="scope.row.WorkYear ? false : true" class="span_error">请填写</span>
                </div>
                <div v-if="registLearnSettings.GzzmVisible">
                  <div v-if="scope.row.PicGzzm==null" @click="fileUpdate('file_gzzm_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">社保缴纳证明</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicGzzm' :id="'img_gzzm_'+scope1.item.EmployeeId" :src="scope1.item.PicGzzm == null ? null : scope1.item.PicGzzm + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_gzzm_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_gzzm_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_gzzm_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 5)">
                </div>

                <div v-if="registLearnSettings.SmpzVisible">
                  <div v-if="scope.row.PicSmpz==null" @click="fileUpdate('file_smpz_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">实名凭证</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicSmpz' :id="'img_smpz_'+scope1.item.EmployeeId" :src="scope1.item.PicSmpz == null ? null : scope1.item.PicSmpz + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_smpz_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_smpz_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_smpz_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 10)">
                </div>
                <div v-if="registLearnSettings.XlzsVisible">
                  <div v-if="scope.row.PicXlzs==null" @click="fileUpdate('file_xlzm_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">学历证书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicXlzs' :id="'img_xlzm_'+scope1.item.EmployeeId" :src="scope1.item.PicXlzs == null ? null : scope1.item.PicXlzs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_xlzm_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_xlzm_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_xlzm_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row,2)">
                </div>
                <div v-if="registLearnSettings.CnsVisible">
                  <div v-if="scope.row.PicCns == null" @click="fileUpdate('file_cns_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">承诺书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row" :src="scope.row.PicCns">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicCns' :id="'img_cns_'+scope1.item.EmployeeId" :src="scope1.item.PicCns == null ? null : scope1.item.PicCns + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_cns_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_cns_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_cns_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row,1)">
                </div>
                <div v-if="registLearnSettings.NativePlaceVisible" class="input_item">
                  <div>
                    <el-select class="k-input" v-model="scope.row.NativePlace" @change="nativePlaceUpdate($event, scope.row.EmployeeId)" clearable placeholder="籍贯">
                      <el-option value=北京市>北京市</el-option>
                      <el-option value=天津市>天津市</el-option>
                      <el-option value=河北省>河北省</el-option>
                      <el-option value=山西省>山西省</el-option>
                      <el-option value=内蒙古自治区>内蒙古自治区</el-option>
                      <el-option value=辽宁省>辽宁省</el-option>
                      <el-option value=吉林省>吉林省</el-option>
                      <el-option value=黑龙江省>黑龙江省</el-option>
                      <el-option value=上海市>上海市</el-option>
                      <el-option value=江苏省>江苏省</el-option>
                      <el-option value=浙江省>浙江省</el-option>
                      <el-option value=安徽省>安徽省</el-option>
                      <el-option value=福建省>福建省</el-option>
                      <el-option value=江西省>江西省</el-option>
                      <el-option value=山东省>山东省</el-option>
                      <el-option value=河南省>河南省</el-option>
                      <el-option value=湖北省>湖北省</el-option>
                      <el-option value=湖南省>湖南省</el-option>
                      <el-option value=广东省>广东省</el-option>
                      <el-option value=广西壮族自治区>广西壮族自治区</el-option>
                      <el-option value=海南省>海南省</el-option>
                      <el-option value=重庆市>重庆市</el-option>
                      <el-option value=四川省>四川省</el-option>
                      <el-option value=贵州省>贵州省</el-option>
                      <el-option value=云南省>云南省</el-option>
                      <el-option value=西藏自治区>西藏自治区</el-option>
                      <el-option value=陕西省>陕西省</el-option>
                      <el-option value=甘肃省>甘肃省</el-option>
                      <el-option value=青海省>青海省</el-option>
                      <el-option value=宁夏回族自治区>宁夏回族自治区</el-option>
                      <el-option value=新疆维吾尔自治区>新疆维吾尔自治区</el-option>
                      <el-option value=香港特别行政区>香港特别行政区</el-option>
                      <el-option value=澳门特别行政区>澳门特别行政区</el-option>
                      <el-option value=台湾省>台湾省</el-option>
                    </el-select>
                  </div>
                  <span v-show="scope.row.NativePlace ? false : true" class="span_error">请选择</span>
                </div>
                <div v-if="registLearnSettings.MajorVisible" class="input_item">
                  <div>
                    <el-input class="k-input" v-model="scope.row.Major" @change="majorUpdate($event, scope.row.EmployeeId)" clearable placeholder="所学专业"></el-input>
                  </div>
                  <span v-show="scope.row.Major ? false : true" class="span_error">请填写</span>
                </div>
                <div v-if="registLearnSettings.DegreeVisible" class="input_item">
                  <div>
                    <el-select class="k-input" v-model="scope.row.EmployeeDegree" @change="degreeUpdate($event, scope.row.EmployeeId)" clearable placeholder="学历">
                      <el-option v-for="item in employeeDegrees" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                    </el-select>
                  </div>
                  <span v-show="scope.row.EmployeeDegreeId ? false : true" class="span_error">请选择</span>
                </div>
                <div v-if="registLearnSettings.BmbVisible">
                  <div v-if="scope.row.PicBmb==null" @click="fileUpdate('file_bmb_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">报名表</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicBmb' :id="'img_bmb_'+scope1.item.EmployeeId" :src="scope1.item.PicBmb == null ? null : scope1.item.PicBmb + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_bmb_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_bmb_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_bmb_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 6)">
                </div>
                <div v-if="registLearnSettings.TjbVisible">
                  <div v-if="scope.row.PicTjb==null" @click="fileUpdate('file_tjb_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">体检表</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicTjb' :id="'img_tjb_'+scope1.item.EmployeeId" :src="scope1.item.PicTjb == null ? null : scope1.item.PicTjb + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_tjb_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_tjb_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_tjb_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row,4)">
                </div>
                <div v-if="registLearnSettings.ZyzsVisible">
                  <div v-if="scope.row.PicZyzs==null" @click="fileUpdate('file_zyzs_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">职称证书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicZyzs' :id="'img_zyzs_'+scope1.item.EmployeeId" :src="scope1.item.PicZyzs == null ? null : scope1.item.PicZyzs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_zyzs_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_zyzs_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_zyzs_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 14)">
                </div>
                <div v-if="registLearnSettings.HgzVisible">
                  <div v-if="scope.row.PicHgz==null" @click="fileUpdate('file_hgz_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">合格证</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicHgz' :id="'img_hgz_'+scope1.item.EmployeeId" :src="scope1.item.PicHgz == null ? null : scope1.item.PicHgz + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_hgz_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_hgz_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_hgz_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 11)">
                </div>
                <div v-if="registLearnSettings.AkzVisible">
                  <div v-if="scope.row.PicAkz==null" @click="fileUpdate('file_akz_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">安考证</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicAkz' :id="'img_akz_'+scope1.item.EmployeeId" :src="scope1.item.PicAkz == null ? null : scope1.item.PicAkz + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_akz_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_akz_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_akz_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 12)">
                </div>
                <div v-if="registLearnSettings.CzzVisible">
                  <div v-if="scope.row.PicCzz==null" @click="fileUpdate('file_czz_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">操作证</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicCzz' :id="'img_czz_'+scope1.item.EmployeeId" :src="scope1.item.PicCzz == null ? null : scope1.item.PicCzz + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_czz_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_czz_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_czz_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 13)">
                </div>
                <div v-if="registLearnSettings.JcyzsVisible">
                  <div v-if="scope.row.PicJcyzs==null" @click="fileUpdate('file_jcyzs_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">检测员证书</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicJcyzs' :id="'img_jcyzs_'+scope1.item.EmployeeId" :src="scope1.item.PicJcyzs == null ? null : scope1.item.PicJcyzs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_jcyzs_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_jcyzs_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_jcyzs_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 17)">
                </div>
                <div v-if="registLearnSettings.ZpVisible">
                  <div v-if="scope.row.PicZp==null" @click="handleUploadAvatar(scope.row.EmployeeId)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:10px;">白底照片480*600</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicZp' :id="'img_zp_'+scope1.item.EmployeeId" :src="scope1.item.PicZp == null ? null : scope1.item.PicZp + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_zp_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="handleUploadAvatar(scope2.item.EmployeeId)">重新上传</div>
                    </template>
                  </k-btn-img>
                </div>
                <div v-if="registLearnSettings.CertificateCodeVisible" class="input_item">
                  <div>
                    <el-input class="k-input" v-model="scope.row.CertificateCode" @change="certificateCodeUpdate($event, scope.row.EmployeeId)" clearable placeholder="证书编号"></el-input>
                  </div>
                  <span v-show="scope.row.CertificateCode ? false : true" class="span_error">请填写</span>
                </div>
                <div v-if="registLearnSettings.CertificateDateVisible" class="input_item">
                  <div>
                    <el-date-picker style="width:190px" v-model="scope.row.CertificateDate" class="k-input" type="date" format="yyyy/MM/dd" value-format="yyyy/MM/dd" placeholder="证书有效期截止日期" @change="certificateDateUpdate($event, scope.row.EmployeeId)">
                    </el-date-picker>
                  </div>
                  <span v-show="scope.row.CertificateDate ? false : true" class="span_error">请填写</span>
                </div>
                <div v-if="registLearnSettings.SqbVisible">
                  <div v-if="scope.row.PicSqb==null" @click="fileUpdate('file_sqb_'+scope.row.EmployeeId,scope.row)" style="display: flex;align-items: center;flex-direction: column;">
                    <div :class="['item-sc-btn','isActive']">
                      <div>+</div>
                      <div style="font-size:14px;">申请表</div>
                    </div>
                    <span class="span_error">请上传</span>
                  </div>
                  <k-btn-img v-else :slides="scope.row">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='scope1.item.PicSqb' :id="'img_sqb_'+scope1.item.EmployeeId" :src="scope1.item.PicSqb == null ? null : scope1.item.PicSqb + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('img_sqb_'+scope2.item.EmployeeId)">查看大图</div>
                      <div @click="fileUpdate('file_sqb_'+scope2.item.EmployeeId, scope.row)">重新上传</div>
                    </template>
                  </k-btn-img>
                  <input type="file" :id="'file_sqb_'+scope.row.EmployeeId" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handlePicSuccess($event,scope.row, 16)">
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="80">
            <template slot-scope="scope">
              <div class="cell-btn" @click="handleRemoveEmployee(scope.row)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                  <path id="trash-alt" class="cls-1" fill="#16cfd0" d="M8.375,13h.75a.375.375,0,0,0,.375-.375V5.875A.375.375,0,0,0,9.125,5.5h-.75A.375.375,0,0,0,8,5.875v6.75A.375.375,0,0,0,8.375,13ZM13.5,2.5H10.925L9.862.728A1.5,1.5,0,0,0,8.575,0H5.425A1.5,1.5,0,0,0,4.138.728L3.075,2.5H.5A.5.5,0,0,0,0,3v.5A.5.5,0,0,0,.5,4H1V14.5A1.5,1.5,0,0,0,2.5,16h9A1.5,1.5,0,0,0,13,14.5V4h.5a.5.5,0,0,0,.5-.5V3A.5.5,0,0,0,13.5,2.5ZM5.37,1.591A.188.188,0,0,1,5.531,1.5H8.469a.188.188,0,0,1,.161.091l.546.909H4.825ZM11.5,14.5h-9V4h9ZM4.875,13h.75A.375.375,0,0,0,6,12.625V5.875A.375.375,0,0,0,5.625,5.5h-.75a.375.375,0,0,0-.375.375v6.75A.375.375,0,0,0,4.875,13Z" />
                </svg>
                &nbsp;删除
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer">
      <el-button class="k-btn" @click="onSubmit">确 定</el-button>
    </div>
    <el-dialog id="dialog_sczp" title="上传电子证件照" top="50px" :visible.sync="uploadAvatarDialogVisible" width="904px" :before-close="handleUploadAvatarDialogCancel">
      <canvas style="display: none;" id="submitCanvas" width="480" height="600"></canvas>
      <div class="box-sczp">
        <div class="box-sczp-content">
          <div style="text-align: center;width: 400px;margin-right:32px;">
            <img src="https://testing-1253588055.cos.ap-shanghai.myqcloud.com/assets/touxiang2.png" class="demo-img">
            <div class="box-sczp-desc">
              上传要求：<br />
              （1）本人近三个月内的正面、免冠、无妆、彩色白底电子证件照片；<br />
              （2）照片类型为 jpg 或 png 格式，大小不超过 2M；<br />
              （3）照片须显示双耳、双眉、双肩；<br />
              （4）不得上传全身照、半身照、风景照、生活照等；<br />
              （5）不得进行 PS 处理，不得美颜。
            </div>
          </div>
          <div>
            <div v-show="picModel.Pic ===''" class="avatar-uploader" onclick="file_avatar.click()" style="width: 400px;height: 300px;margin-bottom:0px">
              <i class="el-icon-plus avatar-uploader-icon" style="line-height: 300px;"></i>
              <input type="file" name="file_avatar" id='file_avatar' class="el-upload__input" multiple accept="image/jpeg,image/jpg" @change="handleAvatarSuccess">
              <div class="avatar-title" style="margin-top: -130px;; font-size: 24px;">点击上传</div>
            </div>
            <div v-show="picModel.Pic !== ''" class="cropper-content">
              <vue-cropper ref="cropper" :viewMode="2" :aspectRatio="(480 / 600)" dragMode="move" :cropBoxResizable="false" :data="{width: 480,
          height: 600}" :minContainerWidth="400" :minContainerHeight="300" :maxContainerWidth="400" :maxContainerHeight="300" :autoCropArea="1" :toggleDragModeOnDblclick="false" :background="false" :src="picModel.Pic" />
              <div class="cxsc-btn" onclick="file_avatar.click()">点击重新上传</div>
            </div>
            <div style="margin-top:17px;color:#16CFD0;font-size:16px;width:400px">
              操作说明：照片上传后可以通过鼠标滚轮进行放大和缩小；拖动高亮区域进行裁剪。
            </div>
          </div>

        </div>
        <div class="box-sczp-fooler">
          <el-button class="el-button el-button--default el-button--small" @click="handleUploadAvatarDialogCancel">取消</el-button>
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="handleUploadAvatarDialogSubmit">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import { mapGetters, ProjectSettings } from '@/views/base/base.js'
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

let viewer = null;

export default {
  components: {
    VueCropper
  },
  data() {
    return {
      courseId: null,
      jobId: null,
      queryModel: {
        Page: 1,
        PageSize: 5,
        Name: null,
        IdNumber: null,
        EmployeeDegreeId: null,
        EmployeeTitleId: null
      },
      employees: [],
      registLearnSettings: [],
      addXyDialogVisible: false,
      uploadAvatarDialogVisible: false,
      Pic: '',
      picModel: {
        EmployeeId: null,
        Pic: '',
        RawFile: null
      },
      pdfIconUrl: 'https://jxjzcj-1253588055.cos.ap-shanghai.myqcloud.com/assets/icon/PDF.png'
    };
  },
  computed: {
    jobInfo: function () {
      let that = this;
      let obj = _.cloneDeep(this.$store.getters.getCommonJob);
      obj.JobId = that.$route.query.jobId;
      return obj;
    },
    ...mapGetters({
      employeeTitles: 'getEmployeeTitle',
      employeeDegrees: 'getEmployeeDegree'
    })
  },

  mounted() {
    let that = this;
    viewer = null;

    let courseId = Number(that.$route.query.courseId);
    let jobId = Number(that.$route.query.jobId);
    that.courseId = courseId;
    that.jobId = jobId;

    this.$store.dispatch('getCommonJob', { jobId: that.jobId }).then(res => {
      document.title = '选择学员 - ' + res.Data.Name + ' - 培训报名 - ' + ProjectSettings.Title;
    });
    this.$store.dispatch('getEmployeeTitle', null);
    this.$store.dispatch('getEmployeeDegree', null);

    // 获得已选学员
    if (this.$route.params.employees) {
      this.employees = this.$route.params.employees;
    } else {
      let enrollStudent = _.find(this.$store.getters.getEnrollStudent, { JobId: that.jobId });
      if (enrollStudent) {
        this.employees = enrollStudent.Employees;
      }
    }

    // 处理验证配置
    let registLearnSettings = _.filter(ProjectSettings.RegistLearnSettings, (item) => {
      if (item.CourseId === courseId && (item.JobIds.length === 0 || item.JobIds.indexOf(jobId) !== -1)) {
        return true;
      }
    });

    if (registLearnSettings.length > 0) {
      that.registLearnSettings = registLearnSettings[0];
    }
  },
  methods: {
    handleAddxy() {
      this.$router.push({
        name: 'courseEnrollAddStudent',
        query: {
          courseId: this.courseId,
          jobId: this.jobId,
          learnId: this.$route.query.learnId
        },
        params: {
          employees: this.employees
        }
      });
    },
    handleRemoveEmployee(row) {
      let that = this;
      this.$confirm('此操作将删除该学员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((response) => {
        that.employees = _.filter(that.employees, t => {
          return t.EmployeeId !== row.EmployeeId;
        });
      }).catch(() => {
      });
    },
    certificateCodeUpdate(val, id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.CertificateCode = val;
    },
    certificateDateUpdate(val, id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.CertificateDate = val;
    },
    nativePlaceUpdate(val, id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.NativePlace = val;
    },
    majorUpdate(val, id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.Major = val;
    },
    degreeUpdate(val, id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.EmployeeDegree = val;
      item.EmployeeDegreeId = null;

      let degree = _.find(this.employeeDegrees, function (d) { return d.Name === val });
      item.EmployeeDegreeId = degree.Id;
    },
    workYearUpdate(val, id) {
      let that = this;
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.WorkYear = val;

      if (that.registLearnSettings.WorkYearVisible && that.registLearnSettings.WorkYearVisible.Min) {
        let minWorkYear = that.registLearnSettings.WorkYearVisible.Min;
        if (item.WorkYear < minWorkYear) {
          item.WorkYear = null;
          that.$alert('工作年限必须为' + minWorkYear + '年及以上', '提示', {
            confirmButtonText: '确定'
          });
        }
      }
    },
    zyzsTypeUpdate(val, id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      item.ZyzsType = val;
      item.FilePsb = null;
    },
    onSubmit() {
      let that = this;

      // 选中人员 与 专业ID
      let job = {
        JobId: that.jobId,
        Employees: []
      };

      let isPush = true;
      _.forEach(that.employees, element => {
        if (that.registLearnSettings.CnsVisible && !element.PicCns) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.ZcjzszsVisible && ((that.courseId !== 3 && !element.PicZcjzszs) || (that.courseId === 3 && !element.PicZcjzszs && element.ZyzsType === 1))) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.TjbVisible && !element.PicTjb) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.CertificateCodeVisible && !element.CertificateCode) {
          this.$alert('请填写证书编号！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.CertificateDateVisible && !element.CertificateDate) {
          this.$alert('请填写相关资料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.BmbVisible && !element.PicBmb) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.SmpzVisible && !element.PicSmpz) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.SfzzmVisible && !element.PicSfzzm) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.SfzfmVisible && !element.PicSfzfm) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.ZpVisible && !element.PicZp) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.SqbVisible && !element.PicSqb) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.HgzVisible && !element.PicHgz) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.AkzVisible && !element.PicAkz) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.CzzVisible && !element.PicCzz) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.WorkYearVisible && !element.WorkYear) {
          this.$alert('请填写相关资料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.NativePlaceVisible && !element.NativePlace) {
          this.$alert('请填写相关资料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.MajorVisible && !element.Major) {
          this.$alert('请填写相关资料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.DegreeVisible && !element.EmployeeDegreeId) {
          this.$alert('请填写相关资料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.PsbVisible && !element.FilePsb && element.ZyzsType === 3) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.ZyzsTypeVisible && !element.ZyzsType) {
          this.$alert('请填写相关资料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        } else if (that.registLearnSettings.GzzmVisible && !element.PicGzzm) {
          this.$alert('请上传相关材料！', '提示', {
            confirmButtonText: '确定'
          });
          isPush = false;
          return;
        }

        // 检测员判断条件
        if (that.courseId === 5) {
          if ((that.registLearnSettings.XlzsVisible && !element.PicXlzs) && (that.registLearnSettings.ZyzsVisible && !element.PicZyzs) && (that.registLearnSettings.JcyzsVisible && !element.PicJcyzs)) {
            this.$alert('请上传相关材料，报名人员应满足工程类专业中专及以上学历、工程类专业初级职称或检测员证书任一条件', '提示', {
              confirmButtonText: '确定'
            });
            isPush = false;
            return;
          }
        } else {
          if (that.registLearnSettings.XlzsVisible && !element.PicXlzs) {
            this.$alert('请上传相关材料！', '提示', {
              confirmButtonText: '确定'
            });
            isPush = false;
            return;
          } else if (that.registLearnSettings.ZyzsVisible && ((that.courseId !== 3 && !element.PicZyzs) || (that.courseId === 3 && !element.PicZyzs && (element.ZyzsType === 2 || element.ZyzsType === 3)))) {
            this.$alert('请上传相关材料！', '提示', {
              confirmButtonText: '确定'
            });
            isPush = false;
            return;
          } else if (that.registLearnSettings.JcyzsVisible && !element.PicJcyzs) {
            this.$alert('请上传相关材料！', '提示', {
              confirmButtonText: '确定'
            });
            isPush = false;
            return;
          }
        }

        // 监理人员课程控制
        if (that.courseId === 3) {
          if (element.ZyzsType === 1) {
            element.PicZyzs = null;
            element.IsUploadPicZyzs = false;
          } else {
            element.PicZcjzszs = null;
            element.IsUploadPicZcjzszs = false;
          }
        }

        job.Employees.push({
          EmployeeId: element.EmployeeId,
          Pic: element.Pic,
          Name: element.Name,
          Sex: element.Sex,
          IdNumber: element.IdNumber,
          EmployeeDegree: element.EmployeeDegree,
          EmployeeDegreeId: element.EmployeeDegreeId,
          EmployeeTitle: element.EmployeeTitle,
          Major: element.Major,
          CertId: element.CertId,
          PicCns: element.PicCns,
          PicXlzs: element.PicXlzs,
          PicZcjzszs: element.PicZcjzszs,
          IsUploadPicXlzs: element.IsUploadPicXlzs,
          IsUploadPicZcjzszs: element.IsUploadPicZcjzszs,
          IsUploadPicSfzzm: element.IsUploadPicSfzzm,
          IsUploadPicSfzfm: element.IsUploadPicSfzfm,
          IsUploadPicZyzs: element.IsUploadPicZyzs,
          PicTjb: element.PicTjb,
          PicGzzm: element.PicGzzm,
          PicBmb: element.PicBmb,
          PicZyzs: element.PicZyzs,
          PicSmpz: element.PicSmpz,
          PicSfzzm: element.PicSfzzm,
          PicSfzfm: element.PicSfzfm,
          PicSqb: element.PicSqb,
          PicZp: element.PicZp,
          PicHgz: element.PicHgz,
          PicAkz: element.PicAkz,
          PicCzz: element.PicCzz,
          PicJcyzs: element.PicJcyzs,
          FilePsb: element.FilePsb,
          CertificateCode: element.CertificateCode,
          CertificateDate: element.CertificateDate,
          WorkYear: element.WorkYear,
          NativePlace: element.NativePlace,
          ZyzsType: element.ZyzsType
        });
      });

      if (isPush) {
        this.$store.dispatch('addEnrollStudent', job);
        this.$router.push({ name: 'courseEnroll', query: { CourseId: this.courseId, LearnId: this.$route.query.learnId } });
      }
    },
    onCancel() {
      this.$router.push({ name: 'courseEnroll', query: { CourseId: this.courseId, LearnId: this.$route.query.learnId } });
    },
    // 上传图片
    handlePicSuccess(ev, row, type) {
      let that = this;
      const rawFile = ev.target.files[0];
      if (!rawFile) return;

      if (!that.beforePicUpload(rawFile)) {
        return;
      }
      try {
        let image = new Image();
        image.src = window.URL.createObjectURL(rawFile);
        image.onload = function () {
          let obj = { Prefix: '', File: rawFile };
          that.$store.dispatch('postUploadPic', obj).then((res) => {
            let item = _.find(that.employees, function (e) { return e.EmployeeId === row.EmployeeId; });
            switch (type) {
              case 1:
                item.PicCns = res.Data;
                break;
              case 2:
                item.IsUploadPicXlzs = true;
                item.PicXlzs = res.Data;
                break;
              case 3:
                item.IsUploadPicZcjzszs = true;
                item.PicZcjzszs = res.Data;
                break;
              case 4:
                item.PicTjb = res.Data;
                break;
              case 5:
                item.PicGzzm = res.Data;
                break;
              case 6:
                item.PicBmb = res.Data;
                break;
              case 7:
                item.IsUploadPicSfzzm = true;
                item.PicSfzzm = res.Data;
                break;
              case 8:
                item.IsUploadPicSfzfm = true;
                item.PicSfzfm = res.Data;
                break;
              case 9:
                let width = image.width;
                let height = image.height;
                if (width === 480 | height === 600) {
                  item.PicZp = res.Data;
                } else {
                  that.$alert('上传照片尺寸应为：480 * 600。', '提示', {
                    confirmButtonText: '确定'
                  });
                }
                break;
              case 10:
                item.PicSmpz = res.Data;
                break;
              case 11:
                item.PicHgz = res.Data;
                break;
              case 12:
                item.PicAkz = res.Data;
                break;
              case 13:
                item.PicCzz = res.Data;
                break;
              case 14:
                item.IsUploadPicZyzs = true;
                item.PicZyzs = res.Data;
                break;
              case 16:
                item.PicSqb = res.Data;
                break;
              case 17:
                item.PicJcyzs = res.Data;
                break;
            }
          });
        };
      } catch (err) {
        console.error(err);
      }
    },
    beforePicUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$alert('上传的资料限制为图片格式!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      if (!isLt2M) {
        this.$alert('上传的资料大小不能超过 2MB!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      return isJPG && isLt2M;
    },
    handlePdfSuccess(ev, row, type) {
      let that = this;
      const rawFile = ev.target.files[0];
      if (!rawFile) return;

      if (rawFile.type !== 'application/pdf') {
        this.$alert('上传的资料限制为 PDF 格式!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }

      console.log('file.type', rawFile.type);
      const isLt2M = rawFile.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$alert('上传的资料大小不能超过 10MB!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }

      try {
        console.log('url', this.pdfIconUrl);
        // let image = new Image();
        // image.src = window.URL.createObjectURL(this.pdfIconUrl);
        // image.onload = function () {
        let obj = { Prefix: '', File: rawFile };
        that.$store.dispatch('postUploadFile', obj).then((res) => {
          let item = _.find(that.employees, function (e) { return e.EmployeeId === row.EmployeeId; });
          switch (type) {
            case 1:
              item.FilePsb = res.Data;
              break;
          }
        });
        // }
      } catch (err) {
        console.error(err);
      }
    },
    fileUpdate(id, row) {
      $('#' + id).click();
    },
    onClickImg(id) {
      if (viewer == null) {
        // 初始化 viewer.js
        viewer = new Viewer(document.getElementById('xytable'), {
          url: 'data-original',
          filter: function (image) {
            if ($(image).prop('src') !== '' && $(image).hasClass('item-sc-img')) {
              return true;
            }
          }
        });
      }
      viewer.update();
      $('#' + id).click();
    },
    onClickPdf(url) {
      let tempwindow = window.open('_blank');
      tempwindow.addEventListener('load', function () {
        tempwindow.location = url;
      });
    },
    handleDeleteFile(employeeId, type) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === employeeId; });
      switch (type) {
        case 1:
          item.PicCns = null;
          break;
        case 2:
          item.IsUploadPicXlzs = false;
          item.PicXlzs = null;
          break;
        case 3:
          item.IsUploadPicZcjzszs = false;
          item.PicZcjzszs = null;
          break;
        case 4:
          item.PicTjb = null;
          break;
        case 5:
          item.PicGzzm = null;
          break;
        case 6:
          item.PicBmb = null;
          break;
        case 7:
          item.IsUploadPicSfzzm = false;
          item.PicSfzzm = null;
          break;
        case 8:
          item.IsUploadPicSfzfm = false;
          item.PicSfzfm = null;
          break;
        case 9:
          item.PicZp = null;
          break;
        case 10:
          item.PicSmpz = null;
          break;
        case 11:
          item.PicHgz = null;
          break;
        case 12:
          item.PicAkz = null;
          break;
        case 13:
          item.PicCzz = null;
          break;
        case 14:
          item.IsUploadPicZyzs = false;
          item.PicZyzs = null;
          break;
        case 16:
          item.PicSqb = null;
          break;
        case 17:
          item.PicJcyzs = null;
          break;
      }
    },
    handleUploadAvatar(employeeId) {
      this.picModel = {
        EmployeeId: employeeId,
        Pic: '',
        RawFile: null
      };
      this.uploadAvatarDialogVisible = true;
    },
    handleUploadAvatarDialogCancel() {
      this.uploadAvatarDialogVisible = false;
    },
    handleUploadAvatarDialogSubmit() {
      let that = this;
      if (this.picModel.Pic === '') {
        this.$alert('请上传电子证件照', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      let promise = new Promise(function (resolve, reject) {
        let imageBase64 = that.$refs.cropper.getCroppedCanvas({
          imageSmoothingQuality: 'high'
        }).toDataURL('image/jpeg');

        let width = 480;
        let height = 600;
        let cropBoxData = that.$refs.cropper.getCropBoxData();
        if (cropBoxData.width !== width || cropBoxData.height !== height) {
          let canvas = document.getElementById('submitCanvas');
          let ctx = canvas.getContext('2d');

          let img = new Image();
          img.src = imageBase64;
          img.onload = function () {
            ctx.width = width;
            ctx.height = height;
            ctx.drawImage(this, 0, 0, ctx.width, ctx.height);
            let imageBase64 = canvas.toDataURL('image/jpeg');
            let size = that.getImgSize(imageBase64);
            if (size > (1024 * 2)) {
              imageBase64 = canvas.toDataURL('image/jpeg', 0.7);
            }
            resolve(imageBase64);
          }
        } else {
          let size = that.getImgSize(imageBase64);
          if (size > (1024 * 2)) {
            imageBase64 = that.$refs.cropper.getCroppedCanvas({
              imageSmoothingQuality: 'high'
            }).toDataURL('image/jpeg', 0.7);
          }
          resolve(imageBase64);
        }
      });

      promise.then(data => {
        let that = this;
        let newFile = that.dataURLtoFile(data);

        let obj = { Prefix: '', File: newFile };
        that.$store.dispatch('postUploadPic', obj).then((res) => {
          let item = _.find(that.employees, function (e) { return e.EmployeeId === that.picModel.EmployeeId; });
          that.picModel.Pic = item.PicZp = res.Data;
          that.uploadAvatarDialogVisible = false;
          // that.$alert(res.Message, '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //   }
          // });
        });
      });
    },
    getImgSize(base64url) {
      // 获取base64图片大小，返回KB数字
      let str = base64url.replace('data:image/jpeg;base64,', '');

      let strLength = str.length;
      let fileLength = parseInt(strLength - (strLength / 8) * 2);
      // 由字节转换为KB
      let size = (fileLength / 1024).toFixed(2);

      return parseInt(size);
    },
    dataURLtoFile(dataurl) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let filename = 'file_zp_' + this.picModel.EmployeeId + '.jpg';
      return new File([u8arr], filename, { type: mime });
    },
    handleAvatarSuccess(ev) {
      let that = this;
      const rawFile = ev.target.files[0];
      if (!rawFile) return;

      if (!that.beforePicUpload(rawFile)) {
        return;
      }

      try {
        let image = new Image();
        image.src = window.URL.createObjectURL(rawFile);
        image.onload = function () {
          that.picModel.Pic = window.URL.createObjectURL(rawFile);
          that.$refs.cropper.replace(that.picModel.Pic);
          // that.$refs.cropper.reset();
        };
      } catch (err) {
        console.error(err);
      }
    },
    handleDeleteAvatar(id) {
      let item = _.find(this.employees, function (e) { return e.EmployeeId === id; });
      this.picModel.Pic = item.PicZp = null;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/list.scss';
.container {
  display: flex;
  flex-direction: column;
  .content {
    .box {
      .title {
        font-size: 30px;
        color: #333333;
        margin-top: 80px;
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;
        .fragment {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .desc {
            color: #ff6715;
            font-size: 14px;
            margin-top: 20px;
          }
        }
      }
      .cell-btn {
        display: flex;
        align-items: center;
        color: #16cfd0;
        cursor: pointer;
      }
    }
    .item-sc-btn {
      display: flex;
      border: 1px solid #dedede;
      color: #dedede;
      cursor: pointer;
      border-radius: 5px;
      width: 136px;
      height: 48px;
      align-items: center;

      div {
        justify-content: center;
        align-items: center;
        display: flex;
      }
      div:first-child {
        width: 32px;
        height: 48px;
        border-right: 1px solid #dedede;
        font-size: 24px;
      }
      div:nth-child(2) {
        width: 104px;
      }
      &.isActive {
        border: 1px solid #ff6715;
        color: #ff6715;
        div:first-child {
          border-right: 1px solid #ff6715;
        }
      }
    }
    .item-sc-img {
      width: 136px;
      height: 48px;
      object-fit: cover;
      border: 1px dashed #dedede;
      cursor: pointer;
      border-radius: 5px;
    }
    .btn-img {
      width: 136px;
      height: 48px;
      display: flex;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 5px;
      position: absolute;
      top: 0;
      div {
        flex: 1;
        font-size: 12px;
        justify-content: center;
        display: flex;
        cursor: pointer;
      }
    }
    .item-imgs {
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      > div {
        margin: 4px 16px 16px 0;
        .span_error {
          color: #ff6715;
          font-size: 14px;
          position: absolute;
          margin-top: 44px;
        }
      }
      .input_item {
        // padding-top: 8px;
        width: 136px;
        margin-top: 0;
        margin: 4px 16px 16px 0;
        .el-input__inner {
          height: 48px !important;
          line-height: 48px !important;
        }
        .span_error {
          margin-top: -4px;
          // margin-left: 48px;
        }
      }
    }
  }
  .footer {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }
  .box-sczp {
    .box-sczp-content {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .cropper-content {
        text-align: center;
        max-width: 400px;
        max-height: 300px;
        position: relative;
        div:first-child {
          height: 300px;
          overflow: hidden;
        }
        .cxsc-btn {
          position: absolute;
          top: 130px;
          left: 128px;
          font-size: 24px;
          color: #fff;
        }
      }
      .demo-img {
        width: 160px;
        height: 200px;
        border: 1px dashed #dedede;
        border-radius: 0;
      }
    }
    .box-sczp-desc {
      width: 408px;
      text-align: left;
      margin-top: 20px;
      font-size: 16px;
      line-height: 24px;
      color: #ff6715;
    }
    .box-sczp-fooler {
      text-align: right;
    }
    .avatar-uploader {
      width: 160px;
      height: 200px;
      margin-bottom: 8px;
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 100%;
        line-height: 200px;
        text-align: center;
      }
      .avatar {
        width: 160px;
        height: 200px;
        display: block;
        position: relative;
        z-index: 2;
      }
      .avatar-title {
        margin-top: -80px;
        display: flex;
        justify-content: center;
        font-size: 14px;
        color: #a8a8a8;
      }
      img {
        border: 1px solid #dedede;
        border-radius: 6px;
        cursor: pointer;
      }
      i {
        border: 1px solid #dedede;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover {
          border-color: #409eff;
        }
      }
      .btn-img {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        border-radius: 5px;
        position: absolute;
        top: 0;
        div {
          flex: none;
          font-size: 12px;
          padding-right: 24px;
          cursor: pointer;
        }
        div:last-child {
          flex: none;
          font-size: 12px;
          padding-right: 0;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style scoped>
.el-table >>> .el-table__row:hover,
.el-table >>> .el-table__row:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}
.input_item >>> .el-input__inner {
  height: 48px !important;
  line-height: 48px !important;
}
.table-xueyuan >>> thead th {
  padding: 16px 0;
  color: #000;
}
.desc >>> a {
  color: #16cfd0 !important;
  font-size: 14px;
}
#dialog_sczp >>> .el-dialog {
  margin: 0 !important;
  width: 904px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#dialog_sczp >>> .el-dialog__header {
  padding: 32px !important;
  padding-bottom: 0px !important;
}
#dialog_sczp >>> .el-dialog__title {
  font-size: 24px !important;
}
#table-empty::before {
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/course_enroll_student.vue